import React from "react";
import BrandSegmented from "../../CoreComponents/BrandSegmented";
import { SCREEN_LABELS } from "./bannerPaths";
import { placementsOn } from "./placements";

const SCREENS = Object.entries(SCREEN_LABELS).map(([value, label]) => ({ value, label }));

export default function PlacementTabs({ screen, placement, onChange }) {
  return (
    <div className="d-flex flex-column align-items-start mb-3" style={{ gap: 12 }}>
      <BrandSegmented
        value={screen}
        options={SCREENS}
        onChange={(value) => onChange({ screen: value, placement: placementsOn(value)[0].id })}
      />
      <BrandSegmented
        value={placement.id}
        options={placementsOn(screen).map((p) => ({ value: p.id, label: p.label }))}
        onChange={(value) => onChange({ placement: value })}
      />
    </div>
  );
}
